import { render, staticRenderFns } from "./standart-faq.vue?vue&type=template&id=34100d5e&scoped=true&"
import script from "./standart-faq.vue?vue&type=script&lang=ts&"
export * from "./standart-faq.vue?vue&type=script&lang=ts&"
import style0 from "./standart-faq.vue?vue&type=style&index=0&id=34100d5e&prod&scoped=true&lang=scss&"
import style1 from "./standart-faq.vue?vue&type=style&index=1&id=34100d5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34100d5e",
  null
  
)

export default component.exports